import {
  successAction,
  GET_FORM_DIRECTIONS,
  GET_FORM_EVENT_TYPES,
  GET_FORM_GAMES,
  GET_FORM_PLATFORMS,
  GET_FORM_RESPONSIBLE,
  GET_FORM_VERSIONS,
  GET_FORM_CHANNELS,
  GET_FORM_TECH_TAGS,
  GET_FORM_TYPE_TAGS,
  GET_FORM_CLASS_TAGS,
} from '../types';

const initialState = {
  directions: [],
  eventTypes: [],
  responsible: [],
  game: [],
  platform: [],
  versions: [],
  channels: [],
  classTags: [],
  techTags: [],
  typeTags: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case successAction(GET_FORM_DIRECTIONS): {
      return {
        ...state,
        directions: action.payload,
      };
    }
    case successAction(GET_FORM_EVENT_TYPES): {
      return {
        ...state,
        eventTypes: action.payload,
      };
    }
    case successAction(GET_FORM_GAMES): {
      return {
        ...state,
        game: action.payload,
      };
    }
    case successAction(GET_FORM_PLATFORMS): {
      return {
        ...state,
        platform: action.payload,
      };
    }
    case successAction(GET_FORM_VERSIONS): {
      return {
        ...state,
        versions: action.payload,
      };
    }

    case successAction(GET_FORM_CHANNELS): {
      return {
        ...state,
        channels: action.payload,
      };
    }

    case successAction(GET_FORM_RESPONSIBLE): {
      return {
        ...state,
        responsible: action.payload,
      };
    }

    case successAction(GET_FORM_TECH_TAGS): {
      return {
        ...state,
        techTags: action.payload,
      };
    }
    case successAction(GET_FORM_TYPE_TAGS): {
      return {
        ...state,
        typeTags: action.payload,
      };
    }
    case successAction(GET_FORM_CLASS_TAGS): {
      return {
        ...state,
        classTags: action.payload,
      };
    }

    default:
      return state;
  }
};
